import React from "react";
import { IoLogoWhatsapp } from "react-icons/io";
const WhatsappComponent = () => {
  const openMessageModal = () => {
    const phoneNumber = "9861934932";
    const whatsappUrl = `https://wa.me/${phoneNumber}`;
    window.open(whatsappUrl, "_blank");
  };
  return (
    <button
      className="fixed right-4 bottom-4 z-40  rounded-full shadow-lg  hover:scale-105 ease-in-out duration-300 focus:outline-none transition-transform transform-gpu bg-white p-2"
      onClick={openMessageModal}
    >
      <IoLogoWhatsapp size={36} color="#10b416" />
    </button>
  );
};

export default WhatsappComponent;
